import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { guid } from 'app/shared/lib/guid';

@autoinject()
export class DemoEssRadio extends ComponentBase {
    protected id: guid = guid();

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) {
        super(...rest);
    }

    ////****************** Example 2 ********************************************////
    protected options: string[] = ['first', 'second', 'third']
    protected selectedOption?: string = 'first';
    protected isDisabled?: boolean = false;
    protected isReadonly?: boolean = false;


    protected toggleIsDisabled(value: boolean): void {
        this.isDisabled = value;
    }

    protected toggleIsReadonly(value: boolean): void {
        this.isReadonly = value;
    }

}
